import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from 'wire-frame';

import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class CardsService {

  private apiUrl: string;

  constructor(private http: HttpClient, private common: CommonService, private apiService: ApiService) { 
    this.apiUrl = this.apiService.getBaseUrl();
  }

  private getAuthHeaders() {
    const token = localStorage.getItem('jwtToken');
    return {
      headers: new HttpHeaders({
        'Authorization' : `Bearer ${token}`
      })
    }
  }

  getCards() {
    return this.http.get(
      this.apiUrl + '/card',
      this.getAuthHeaders()
    );
  }

  getCard(id: number | string) {
    return this.http.get(
      this.apiUrl + '/card/' + id,
      this.getAuthHeaders()
    );
  }

  createCard(payload: {
    number?: string;
    clinic_id?: number;
    status?: string;
    total_dues?: number;
  }) {
    return this.http.post(
      this.apiUrl + '/card',
      payload,
      this.getAuthHeaders()
    );
  }

  searchCards(query: string, limit = 20) {
    return this.http.get(
      this.apiUrl + '/card/search',
      {
        ...this.getAuthHeaders(),
        params: {
          q: query,
          limit: String(limit),
        },
      }
    );
  }

  getNextCardNumber(clinicId: number) {
    return this.http.get(
      this.apiUrl + '/card/next-number',
      {
        ...this.getAuthHeaders(),
        params: {
          clinic_id: String(clinicId),
        },
      }
    );
  }

  deleteCard(payload: any) {
    payload["action"] = "deleteCard";
    return this.http.delete(
      this.apiUrl + '/card/' + payload.id, this.getAuthHeaders()
    );
  }

  movePatient(payload: any) {
    return this.http.post(this.apiUrl + '/card/move-patient', payload, this.getAuthHeaders());
  }

  ccAvenueCardDuesPayment(payload: any) {
    return this.http.post(this.apiUrl + '/ccavenue-card-request', payload);
  }

  settleCashDues(payload: any) {
    return this.http.post(this.apiUrl + '/settle-cash-dues', payload, this.getAuthHeaders())
  }
}
